<template>
  <v-container fluid>
    <v-card>
      <v-card-title
        primary-title
        style="padding-left: 8px; padding-bottom: 8px"
      >
        <span class="headline mb-0">送信履歴</span>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="goToList()">{{ $t('app.buttons.back') }}</v-btn>
      </v-card-actions>
    </v-card>
    <v-card class="mt-2">
      <v-data-table
        :headers="headers"
        :items="results"
        :pagination.sync="pagination"
        :rows-per-page-items="[10]"
        :total-items="pagination.totalItems"
        class="elevation-0"
        item-key="seq"
      >
        <template slot="items" slot-scope="props">
          <td
            class="over-content"
            style="max-width:200px"
            v-for="(header, index) in headersWithoutDetail"
            :key="index"
          >
            <span :title="props.item[header.value]">{{
              props.item[header.value]
            }}</span>
          </td>
          <td>
            <v-btn
              :disabled="!props.item.jsonBody"
              @click="goToDetail(props.item)"
              >B/L詳細</v-btn
            >
          </td>
        </template>
      </v-data-table>
    </v-card>
    <csv-fields ref="csvFields" />
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      headers: [
        {
          text: '#',
          value: 'seq',
          sortable: false,
        },
        {
          text: '送信時間',
          value: 'createTime',
          sortable: false,
        },
        {
          text: '送信者',
          value: 'senderName',
          sortable: false,
        },
        {
          text: '宛先アドレス',
          value: 'showInfos',
          sortable: false,
        },
        {
          text: '件名',
          value: 'subTitle',
          sortable: false,
        },
        {
          text: 'メール送信区分',
          value: 'eventStatus',
          sortable: false,
        },
        {
          text: '備考',
          value: 'remark',
          sortable: false,
        },
        {
          text: '詳細仕分',
          value: 'detail',
          sortable: false,
        },
      ],
      query: {},
      pagination: {
        page: 1,
      },
      selected: [],
      results: [],
    }
  },
  methods: {
    load() {
      this.$http
        .get(`tdoc/mails/history?blNo=${this.$route.query.blNo}`)
        .then((res) => {
          this.results = res.data.map((r, index) => {
            return {
              ...r,
              seq: index + 1,
            }
          })
        })
    },
    goToList() {
      this.$router.push('/t-doc')
    },
    goToDetail(bl) {
      console.log(bl)
      this.$router.push({
        name: 'TdocNew',
        query: {
          disabled: true,
          eventId: bl.id,
        },
      })
      // this.$router.push('/t-doc/New')
    },
  },
  mounted() {
    this.load()
  },
  computed: {
    headersWithoutDetail() {
      return this.headers.filter((h) => h.value !== 'detail')
    },
  },
}
</script>

<style scoped>
.bl-date-wrap {
  display: flex;
}

table.options {
  font-size: 12px;
  border: 1px solid #ccc;
  width: 100%;
}

table.options td {
  padding: 14px 5px;
}

table.options tr td:not(:first-child) {
  text-align: center;
}

table.options /deep/.v-radio {
  margin: auto;
}

table.options /deep/.v-input--selection-controls__input {
  margin: auto;
}

.options-label {
  font-size: 12px;
}
</style>
